import { UseMutationResult } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { UseFormReturn } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import useShop from "../../hooks/useShop.hook";
import { ShelfFormData } from "../../types/shelf";
import { EditorSection, SubmitPanel, Title } from "../reuseables/editor.comp";
import { LabelAndInput } from "../reuseables/form.comp";

export default function ShelfEditor({
  methods,
  mutation,
  btnName,
}: {
  methods: UseFormReturn<ShelfFormData, any>;
  mutation: UseMutationResult<void, unknown, ShelfFormData, unknown>;
  btnName: string;
}) {
  const { t, msg } = useTranslation();
  const selectedShop = useShop();
  const { push } = useRouter();

  async function onSubmit(data: ShelfFormData) {
    mutation.mutate(data);
  }

  if (!selectedShop) return null;

  return (
    <form onSubmit={methods.handleSubmit(onSubmit)} className="pb-2">
      <EditorSection>
        <Title>{t(msg.product.generalInfo)}</Title>
        <div className="text-xs flex flex-col gap-4">
          <LabelAndInput register={methods.register} fieldName="name" label={t(msg.shelf.name)} topLabelCss="block" />
        </div>
      </EditorSection>
      <SubmitPanel>
        <button onClick={() => push("/shelves")}>{t(msg.form.cancel)}</button>
        <input type="submit" value={btnName} />
      </SubmitPanel>
    </form>
  );
}
